// extracted by mini-css-extract-plugin
export default {"-large":"KjsiPRNHgS_RX5tvZYSG","dropdown":"HeXosuh4B_zUynJLKQZ5","dropdownList":"qqO4ej0K4AowSKqGALMN"};